module.exports = __webpack_public_path__ + "static/media/kin_success.e9def551.png";